import {Component, Vue} from 'vue-property-decorator';
import DictionaryEntity from '@/entities/DictionaryEntity';

@Component
export default class StateService extends Vue {

    private static loadState(): DictionaryEntity {
        const json: string|undefined = localStorage.state;
        if (json === undefined) {
            return {};
        }
        return JSON.parse(json);
    }

    private static storeState(state: DictionaryEntity): void {
        localStorage.state = JSON.stringify(state);
    }

    public coins: number = 0;

    public localStorageHandler(): void {
        const propertyNames = Object.getOwnPropertyNames(this).filter((name) => {
            const ignoringPrefixes = ['_', '$'];
            const ignoringNames = ['localStorageHandler'];
            return !ignoringPrefixes.includes(name[0])
                && !ignoringNames.includes(name);
        });
        for (const propertyName of propertyNames) {
            this.$watch(propertyName, (value: any) => {
                const state = StateService.loadState();
                state[propertyName] = value;
                StateService.storeState(state);
            });
        }
    }

    // noinspection JSUnusedGlobalSymbols
    public created() {
        this.localStorageHandler();
        const state = StateService.loadState();
        for (const propertyName of Object.keys(state)) {
            // @ts-ignore
            this[propertyName] = state[propertyName];
        }
    }
}
